/* src/app/forms/produtos/mercadolivre/meli-item/meli-attributes/meli-attributes.component.scss */
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding-right: 10px;
}
.dialog-title {
  margin: 0 0 8px 0;
  font-size: var(--tem-fs-lg, 18px);
  font-weight: 600;
}
.dialog-content {
  flex: 1;
  overflow: auto;
}
.dialog-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 0;
  border-top: 1px solid var(--tem-border, #f0f0f0);
}
.variation_body {
  height: 100%;
  overflow: auto;
}
.list-content {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  position: relative;
}
.maincontainer {
  position: relative;
}
/*# sourceMappingURL=meli-attributes.component.css.map */
